export default __webpack_public_path__ + "styles/billboard.6c86564253a8559e.css";